<template>
  <div>
    <MasterLayout>
      <div class="quickfuel_first_row">
        <div
          class="quickfuel_first_row_right_section"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center quick_fuel">
            <div class="col-md-6 col-lg-12 text-center">
              <img src="@/assets/img/racing.png" class="mr-5" />
              <span class="quick_fuel_banner_header">{{
                $t("text.extendedReport.quickFuel")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3">
        <div class="row add_driver_row">
          <div class="col-md-12 col-lg-5 add-driver_form_row">
            <div class="driver_form_row">
              <h3 class="add_driver_header text-center py-3">
                {{ $t("text.extendedReport.quick") }}
              </h3>
              <div class="Add_driver_form">
                <div class="form_input_section mt-5">
                  <div class="input__div" ref="firstname_input_div">
                    <div class="placeholder_div">
                      <img
                        src="@/assets/img/payment-method.png"
                        width="50%"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="text"
                        placeholder="Select Payment Method"
                        readonly
                        @click="toggleDropdownDisplay"
                        v-model="QuickFuelMethod"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="quick_fuel_payment_method_dropdown"
                  ref="quick_fuel_dropdown"
                  v-if="toggleQucikFuelMethodsDropdown"
                >
                  <hr class="mt-2" />
                  <div
                    class="row mt-2 active_quick_fuel_method align-items-center"
                    ref="bankListRow"
                    @click="getQuickFuelMethod('Phone Number')"
                  >
                    <div class="col-md-8">
                      <h3
                        class="dropdown_header_text mt-2 quick_fuel_payment_mthod_list_text"
                        ref="quick_fuel_payment_mthod_list_text"
                      >
                        {{ $t("text.extendedReport.phone") }}
                      </h3>
                    </div>
                    <div class="col-md-4 text-right"></div>
                  </div>
                  <!-- <div class="row mt-2 active_quick_fuel_method align-items-center" 
                                            ref="bankListRow" 
                                             @click="getQuickFuelMethod('Magnetic Stripe Card')">
                                        <div class="col-md-8">
                                            <h3 class="dropdown_header_text mt-2 quick_fuel_payment_mthod_list_text" ref="quick_fuel_payment_mthod_list_text" >Magnetic Stripe Card</h3>
                                        </div>
                                            <div class="col-md-4 text-right">
                                        </div>
                                    </div> -->
                </div>
                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <div
                      class="form_input_section mt-5"
                      v-if="QuickFuelMethod === 'Phone Number'"
                    >
                      <div class="input__div" ref="phone_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/phone.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            placeholder="Phone Number"
                            @input="captureFormEvents($event)"
                            v-model="phoneNumber"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="phone_error_message"
                      style="display: none"
                      v-if="QuickFuelMethod === 'Phone Number'"
                    ></div>
                    <div
                      class="form_input_section mt-5"
                      v-if="QuickFuelMethod === 'Magnetic Stripe Card'"
                    >
                      <div class="input__div" ref="card_number_error_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/credit-card(1).png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            placeholder="Card Number"
                            @input="captureFormEvents($event)"
                            v-model="magneticCardStripe"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="card_number_error_template"
                      style="display: none"
                      v-if="QuickFuelMethod === 'Magnetic Stripe Card'"
                    ></div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="form_input_section mt-5">
                      <div class="input__div" ref="amount_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/Path 586.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            placeholder="Amount"
                            @input="captureFormEvents($event)"
                            v-model="amount"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="amount_error_template"
                      style="display: none"
                    ></div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12 col-lg-6">
                    <div class="form_input_section mt-5">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="password"
                            placeholder="Pin"
                            @input="captureFormEvents($event)"
                            v-model="pin"
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="form_input_section mt-5">
                      <div class="input__div" ref="confirm_pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="password"
                            placeholder="Confirm Pin"
                            v-model="confirmPin"
                            @input="captureFormEvents($event)"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="confirm_pin_error_template"
                      style="display: none"
                    ></div>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    class="add_quick_fuel_btn"
                    @click="addQuickFuel($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    Add <span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-7">
            <div class="drivers_list mr-3">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column field="index" width="100" headerText="#"></e-column>
                  <e-column
                    field="method"
                    width="100"
                    headerText="METHOD"
                  ></e-column>
                  <e-column
                    field="uniqueId"
                    width="100"
                    headerText="NUMBER"
                  ></e-column>
                  <e-column
                    field="maxAmount"
                    width="100"
                    headerText="MAXIMUM AMOUNT"
                  ></e-column>
                  <e-column
                    :template="deleButtonTemplate"
                    width="100"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Quick Fuel:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      toggleQucikFuelMethodsDropdown: false,
      QuickFuelMethod: null,
      cardNumber: null,
      amount: null,
      pin: null,
      confirmPin: null,
      formIsValid: false,
      QuickFuelMethodInput: null,
      phoneNumber: null,
      magneticCardStripe: null,
      isButtonDisabled: false,
      quickFuelDetails: null,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      deleButtonTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeQuickFuel(data.id)">Delete</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeQuickFuel: function (id) {
                this.$eventHub.$emit("deleteQuickFuel", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("deleteQuickFuel", (id) => {
      this.deleteQuickFuelDetail(id);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("deleteQuickFuel");
  },
  mounted() {
    this.getQuickFuelDetails();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    deleteQuickFuelDetail(id) {
      var resp = confirm("Are you sure  you want to delete this method?");
      if (resp) {
        let data = {
          id: id,
        };
        this.axios
          .post(
            `${configObject.apiBaseUrl}/Wallet/RemoveQuickFuelMethod`,
            data,
            configObject.authConfig()
          )
          .then(() => {
            this.$toast.open({
              message: "Successfully removed Quick Fuel Detail",
              type: "success",
              duration: 3000,
            });
            this.getQuickFuelDetails();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 3000,
            });
          });
      }
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet");
    },
    toggleDropdownDisplay() {
      this.toggleQucikFuelMethodsDropdown =
        !this.toggleQucikFuelMethodsDropdown;
    },
    getQuickFuelMethod(QuickFuelMethod) {
      this.toggleQucikFuelMethodsDropdown =
        !this.toggleQucikFuelMethodsDropdown;
      this.QuickFuelMethod = QuickFuelMethod;
    },
    getQuickFuelDetails() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/QuickFuel`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.forEach((quickFuel) => {
            index++;
            quickFuel.maxAmount = quickFuel.maxAmount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            quickFuel.index = index;
          });
          this.showLoader = false;

          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    addQuickFuel($event) {
      $event.preventDefault();
      let data;
      if (!this.QuickFuelMethod) {
        this.$toast.open({
          message: "Please select a quick Fuel method",
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.pin !== this.confirmPin) {
        this.$toast.open({
          message: "Passwords don't match, try again",
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.phoneNumber) {
        this.$toast.open({
          message: "Please select a Phone Number",
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.amount) {
        this.$toast.open({
          type: "error",
          message: "Please Inpuit a valid Amount",
          duration: 3000,
        });
        return;
      }
      if (!this.pin) {
        this.$toast.open({
          type: "error",
          message: "Please Input a pin ",
          duration: 3000,
        });
        return;
      }
      if (!this.confirmPin) {
        this.$toast.open({
          type: "error",
          message: "Please confirm your pin ",
          duration: 3000,
        });
        return;
      }
      if (this.QuickFuelMethod === "Phone Number") {
        data = {
          uniqueId: this.phoneNumber,
          maxAmount: parseFloat(this.amount),
          pin: this.pin,
          method: this.QuickFuelMethod,
          confirmPin: this.confirmPin,
        };
      }
      if (this.QuickFuelMethod === "Magnetic Stripe Card") {
        data = {
          uniqueId: this.magneticCardStripe,
          maxAmount: parseFloat(this.amount),
          pin: this.pin,
          method: this.QuickFuelMethod,
          confirmPin: this.confirmPin,
        };
      }

      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/AddQuickFuel`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: "Successfully Added Quick Fuel Method",
            type: "success",
            duration: 10000,
          });
          $(".loader").hide();
          $(".checked_icon").show();
          _this.getQuickFuelDetails();
          this.isButtonDisabled = false;
          data = null;
          this.pin = null;
          this.confirmPin = null;
          this.QuickFuelMethod = null;
          this.magneticCardStripe = null;
          this.phoneNumber = null;
          this.amount = null;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === "Card Number") {
        if ($event.target.value === "") {
          this.$refs.card_number_error_template.style.display = "block";
          this.$refs.card_number_error_template.innerHTML =
            "Card Number field cannot be blank";
          this.$refs.card_number_error_template.style.color = "red";
          this.$refs.card_number_error_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.card_number_error_template.style.display = "none";
          this.$refs.card_number_error_template.innerHTML = "";
          this.$refs.card_number_error_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === "Phone Number") {
        if ($event.target.value === "") {
          this.$refs.phone_error_message.style.display = "block";
          this.$refs.phone_error_message.innerHTML =
            "Phone Number field cannot be blank";
          this.$refs.phone_input_div.style.border = "1px solid red";
          this.$refs.phone_error_message.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error_message.style.display = "block";
            this.$refs.phone_error_message.style.color = "red";
            this.$refs.phone_input_div.style.border = "1px solid red";
            this.$refs.phone_error_message.innerHTML =
              "Phone number should be betwween 10 and 13 characters";
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error_message.style.display = "none";
          this.$refs.phone_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === "Amount") {
        if ($event.target.value === "") {
          this.$refs.amount_error_template.style.display = "block";
          this.$refs.amount_error_template.innerHTML =
            "Amount field cannot be blank";
          this.$refs.amount_input_div.style.border = "1px solid red";
          this.$refs.amount_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.amount_error_template.style.display = "none";
          this.$refs.amount_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === "Pin") {
        if ($event.target.value === "") {
          this.$refs.pin_error_template.style.display = "block";
          this.$refs.pin_error_template.innerHTML = "Pin field cannot be blank";
          this.$refs.pin_error_template.style.color = "red";
          this.$refs.pin_input_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.pin_error_template.style.display = "none";
          if ($event.target.value.length < 4) {
            this.$refs.pin_error_template.style.display = "block";
            this.$refs.pin_error_template.innerHTML =
              "Pin cannot be less than four(4)";
            this.$refs.pin_error_template.style.color = "red";
            this.$refs.pin_input_div.style.border = "1px solid red";
            this.formIsValid = false;
          } else {
            this.$refs.pin_input_div.style.border =
              "1px solid rgb(75, 44, 114)";
            this.$refs.pin_error_template.style.display = "none";
            this.formIsValid = false;
          }
        }
      }
      if ($event.target.placeholder === "Confirm Pin") {
        if ($event.target.value === "") {
          this.$toasted.show("Confirm Pin Field cannot be blank", {
            theme: "bubble",
            position: "top-center",
            duration: 2000,
          });
          this.$refs.confirm_pin_error_template.style.display = "block";
          this.$refs.confirm_pin_error_template.innerHTML =
            "COnfirm Pin  field cannot be blank";
          this.$refs.confirm_pin_input_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.confirm_pin_error_template.style.display = "none";
          if (this.pin !== this.confirmPin) {
            this.$refs.confirm_pin_input_div.style.border = "1px solid red";
            this.$refs.confirm_pin_error_template.style.display = "block";
            this.$refs.confirm_pin_error_template.style.color = "red";
            this.$refs.confirm_pin_error_template.innerHTML =
              "Pins don't match";
            this.formIsValid = false;
          } else {
            this.$refs.confirm_pin_error_template.style.display = "none";
            this.$refs.confirm_pin_input_div.style.border =
              "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          }
        }
      }
    },
  },
};
</script>
